/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_EditInputs */

const vi_expense_edit = /** @type {(inputs: Expense_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa khoản chi`)
};

/**

* @param {Expense_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_edit = /** @type {((inputs?: Expense_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_edit(inputs)
});